import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useTranslation } from "react-i18next";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const PlayoffOverview = ({ leagueData }) => {
  const { eliminatedCount, userCount } = leagueData;
  const { t } = useTranslation();

  let remainingCount = userCount - eliminatedCount;

  const labels = ["Eliminated", "Remaining"];
  const dataset = [eliminatedCount, remainingCount];

  const options = {
    showLabel: false,
    responsive: true,
    maintainAspectRatio: false,
    borderWidth: 1,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        display: false,
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        data: dataset,
        backgroundColor: ["rgba(0, 0, 0, 0.5)", "rgba(236, 72, 153, 0.8)"],
      },
    ],
  };
  return (
    <div className="flex w-full h-full items-center justify-center space-x-2 mx-2">
      <div className="flex w-full justify-center items-center flex-col bg-black/60 text-white p-2 rounded-lg">
        <div className="text-lg font-medium text-white">{remainingCount}</div>
        <div className="text-xs text-white">
          {t("tournament.leaderboard.remaining")}
        </div>
      </div>
      <div className="flex  h-20 w-20 relative shrink-0">
        <Pie options={options} data={data} />
      </div>
      <div className="flex w-full justify-center items-center flex-col bg-black/60 text-white p-2 rounded-lg">
        <div className="text-lg font-medium text-white">{eliminatedCount}</div>
        <div className="text-xs text-white">
          {t("tournament.leaderboard.eliminated")}
        </div>
      </div>
    </div>
  );
};

export default PlayoffOverview;
